/**
 * What a box on the count sheet was given (2026-10-21).
 *
 * The sheet jumps to a size when its label is scanned, and leaves the caret in
 * that size's box for the count. Scan the same label again — the natural
 * thing with an item in hand — and the scanner types the label's digits into
 * the box and presses Enter. Read as a count, a SKU like 034512 would have
 * been saved as 34,512 on the shelf. So a run of six digits or more is a
 * **scan**: the sheet finds that size again and the count is left as it was.
 * No shelf holds a hundred thousand of one size, and the server refuses a
 * count that high anyway; every SKU and UPC the store prints is six digits or
 * longer.
 */
export type SheetEntry =
  | { readonly kind: 'unchanged' }
  | { readonly kind: 'clear' }
  | { readonly kind: 'count'; readonly value: number }
  | { readonly kind: 'scan'; readonly code: string };

/** The fewest digits a scanned code has: a six-digit SKU. */
export const SCANNED_DIGITS = 6;

export function readSheetEntry(typed: string, shown: string): SheetEntry {
  const text = typed.trim();
  if (text === shown) return { kind: 'unchanged' };
  if (text === '') return { kind: 'clear' };
  if (!/^\d+$/.test(text)) return { kind: 'unchanged' };
  if (text.length >= SCANNED_DIGITS) return { kind: 'scan', code: text };
  return { kind: 'count', value: Number(text) };
}
